import { clsx } from "clsx";

import styles from "./SectionTypography.module.scss";

interface SectionComponent {
    children?: JSX.Element | string;
    className?: string;
}

export function PageTitle({ children, className }: SectionComponent): JSX.Element {
    return <h1 className={clsx(styles.pageTitle, className)}>{children}</h1>;
}

export function SectionTitle({ children, className }: SectionComponent): JSX.Element {
    return <h2 className={clsx(styles.sectionTitle, className)}>{children}</h2>;
}

export function SectionSubTitle({ children, className }: SectionComponent): JSX.Element {
    return <h3 className={clsx(styles.sectionSubTitle, className)}>{children}</h3>;
}

export function SectionDescription({ children, className }: SectionComponent): JSX.Element {
    return <p className={clsx(styles.sectionDescription, className)}>{children}</p>;
}
